import React from 'react';
import { render as ReactRender, createPortal as ReactCreatePortal } from 'react-dom';
import qs from 'qs';
import SearchHeader from './algolia/search-header';
import AvailableIndices from './algolia/search-indices';
import { MobileContext } from './util/mobile-context';
import ShowIf from './util/show-if';
import algoliasearch from "algoliasearch";
import { InstantSearch, connectStateResults, connectInfiniteHits, Index, Configure, Snippet, Highlight } from 'react-instantsearch-dom';
import _uniqBy from 'lodash/uniqBy';
import _flatten from 'lodash/flatten';
import { SearchContext } from './algolia/search-context';
jQuery(function ($) {
    const $searchRoot = $("#wm-searchRoot");
    const $searchResultRoot = $("#wm-searchResults");
    const $searchFooter = $("#wm-searchFooter");
    if ($searchRoot.length !== 1 || $searchResultRoot.length !== 1 || $searchFooter.length !== 1) {
        return;
    }
    const searchClient = algoliasearch('S36ND6JMMI', '4fef63e69a29ca872d6e44d6b266b76a');
    const checkIsMobile = () => {
        return $(window).width() <= 1024;
    };
    const SearchResultsPortal = ({ children }) => ReactCreatePortal(children, $searchResultRoot.get(0));
    const SearchHeaderPortal = ({ children }) => (React.createElement(React.Fragment, null, children));
    const SearchFooterPortal = ({ children }) => ReactCreatePortal(children, $searchFooter.get(0));
    const CSStats = connectStateResults(({ hitCount, searchResults }) => {
        return (React.createElement(React.Fragment, null, !!searchResults ? React.createElement(React.Fragment, null,
            "(",
            larry.search.showing,
            " ",
            hitCount,
            "/",
            searchResults.nbHits,
            " ",
            larry.search.results,
            ")") : undefined));
    });
    const CSHit = connectInfiniteHits(({ hits, refineNext, hasMore, showThumbnail, showTitle, showContent, showCategories, noResultsText }) => {
        const items = hits.map(hit => {
            return (React.createElement("li", { key: hit.objectID, className: 'wm-searchResultSection__item', "data-oid": hit.objectID, "data-id": hit.id, "data-type": hit.type, "data-slug": hit.slug },
                React.createElement("a", { className: 'wm-searchResultSection__itemOuter', href: hit.url, target: '_blank' },
                    React.createElement(ShowIf, { show: showThumbnail },
                        React.createElement("img", { className: "wm-searchResultSection__itemThumbnail", src: hit.thumbnail })),
                    React.createElement("div", { className: 'wm-searchResultSection__itemInner' },
                        React.createElement("div", { className: "wm-searchResultSection__itemContent" },
                            React.createElement(ShowIf, { show: showTitle },
                                React.createElement("h3", { className: "wm-searchResultSection__itemTitle" },
                                    React.createElement(Highlight, { hit: hit, attribute: 'title', tagName: 'mark' }))),
                            React.createElement(ShowIf, { show: showContent },
                                React.createElement("div", { className: "wm-searchResultSection__itemContent" },
                                    React.createElement(Snippet, { hit: hit, attribute: 'content', tagName: 'mark' }))),
                            React.createElement(ShowIf, { show: showCategories }))))));
        });
        if (items.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement("ul", null, items),
                React.createElement("span", { className: 'wm-searchResultSection__queryInfo' },
                    React.createElement(CSStats, { hitCount: hits.length })),
                React.createElement("button", { className: 'wm-searchResultSection__showMore', onClick: refineNext, disabled: !hasMore },
                    React.createElement("span", null, larry.search.showMore),
                    React.createElement("i", { className: "fas fa-arrow-down" }))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: 'wmsearchResultSection__queryInfo -srsNoResults' }, noResultsText)));
    });
    const urlToSearchState = () => {
        const search = window.location.search.slice(1);
        if (!search || search.length === 0)
            return {};
        const parse = qs.parse(search);
        return {
            query: (parse.q || ''),
            menu: {
                categories: (parse.cat || ''),
            },
        };
    };
    const SearchContainer = () => {
        const [searchState, setSearchState] = React.useState(urlToSearchState());
        const [isMobile, setIsMobile] = React.useState(checkIsMobile());
        const [availableCategories, setAvailableCategories] = React.useState([]);
        const debouncedSetStateRef = React.useRef(null);
        const mobileThrottle = React.useRef(null);
        const updateIsMobile = (isMobile) => {
            clearTimeout(mobileThrottle.current);
            mobileThrottle.current = setTimeout(() => {
                setIsMobile(isMobile);
            }, 200);
        };
        const onSearchStateChange = React.useCallback((newState) => {
            var _a, _b, _c, _d, _e, _f, _g;
            clearTimeout(debouncedSetStateRef.current);
            debouncedSetStateRef.current = setTimeout(() => {
                var _a;
                const stateToSave = {
                    q: newState.query || '',
                    cat: ((_a = newState.menu) === null || _a === void 0 ? void 0 : _a.categories) || '',
                };
                const url = new URL(window.location.href);
                url.searchParams.set('q', stateToSave.q);
                url.searchParams.set('cat', stateToSave.cat);
                history.pushState({}, '', url);
            }, 400);
            if (searchState.query === newState.query && ((_a = searchState.menu) === null || _a === void 0 ? void 0 : _a.categories) !== ((_b = newState.menu) === null || _b === void 0 ? void 0 : _b.categories)) {
                newState.query = '';
            }
            else if (searchState.query !== newState.query && ((_c = searchState.menu) === null || _c === void 0 ? void 0 : _c.categories) === ((_d = newState.menu) === null || _d === void 0 ? void 0 : _d.categories)) {
                if ((_e = newState.menu) === null || _e === void 0 ? void 0 : _e.categories)
                    newState.menu.categories = '';
            }
            if (searchState.query !== newState.query || ((_f = searchState.menu) === null || _f === void 0 ? void 0 : _f.categories) !== ((_g = newState.menu) === null || _g === void 0 ? void 0 : _g.categories)) {
                if (isMobile) {
                    window.scroll({
                        top: $searchResultRoot.offset().top,
                        behavior: 'smooth',
                    });
                }
                else {
                    window.scroll({
                        top: $searchResultRoot.offset().top - 260,
                        behavior: 'smooth',
                    });
                }
            }
            setSearchState(newState);
        }, [isMobile, searchState]);
        const onRestartSearchClick = React.useCallback((event) => {
            event.preventDefault();
            window.scroll({
                top: 0,
                behavior: 'smooth',
            });
            setSearchState(state => (Object.assign(Object.assign({}, state), { query: '', menu: {} })));
        }, [setSearchState]);
        React.useEffect(() => {
            const onResize = () => {
                updateIsMobile(checkIsMobile());
            };
            window.addEventListener('resize', onResize, { passive: true });
            return () => {
                window.removeEventListener('resize', onResize);
            };
        }, []);
        React.useEffect(() => {
            (async () => {
                const response = await searchClient.multipleQueries([
                    {
                        facet: 'categories',
                        indexName: AvailableIndices.post.index,
                        type: 'facet',
                        params: {
                            maxFacetHits: 8,
                            filters: 'lang:' + larry.lang
                        },
                    },
                    {
                        facet: 'categories',
                        indexName: AvailableIndices.page.index,
                        type: 'facet',
                        params: {
                            maxFacetHits: 8,
                            filters: 'lang:' + larry.lang
                        },
                    },
                    {
                        facet: 'categories',
                        indexName: AvailableIndices.video.index,
                        type: 'facet',
                        params: {
                            maxFacetHits: 8,
                            filters: 'lang:' + larry.lang
                        },
                    },
                ]);
                const results = response.results;
                const hits = _uniqBy(_flatten(results.map(r => r.facetHits)), hit => hit.value);
                const facets = hits.map(hit => ({ label: hit.value, value: hit.value, isRefined: false, count: 0 })).slice(0, 8);
                setAvailableCategories(facets);
            })();
        }, []);
        return (React.createElement(MobileContext.Provider, { value: isMobile },
            React.createElement(SearchContext.Provider, { value: { categoryFacets: availableCategories } },
                React.createElement(InstantSearch, { indexName: AvailableIndices.post.index, searchClient: searchClient, searchState: searchState, onSearchStateChange: onSearchStateChange },
                    React.createElement(SearchHeaderPortal, null,
                        React.createElement(SearchHeader, { searchClient: searchClient })),
                    React.createElement(SearchResultsPortal, null,
                        React.createElement(ShowIf, { show: !isMobile },
                            React.createElement("div", { className: 'wm-searchResults__reset' },
                                React.createElement("a", { className: 'wm-button', onClick: onRestartSearchClick, href: "#" }, larry.search.newSearch))),
                        React.createElement("div", { className: "wm-searchResultSections" },
                            React.createElement("div", { className: 'wm-searchResultSection -srsPost' },
                                React.createElement("h2", null, larry.search.articlesAndBlogposts),
                                React.createElement(Configure, { hitsPerPage: AvailableIndices.post.hitsPerPage, filters: 'lang:' + larry.lang }),
                                React.createElement(CSHit, { showThumbnail: false, showTitle: true, showContent: false, showCategories: false, noResultsText: larry.search.noArticles })),
                            React.createElement("div", { className: 'wm-searchResultSection -srsPage' },
                                React.createElement("h2", null, larry.search.pages),
                                React.createElement(Index, { indexName: AvailableIndices.page.index },
                                    React.createElement(Configure, { hitsPerPage: AvailableIndices.page.hitsPerPage, filters: 'lang:' + larry.lang }),
                                    React.createElement(CSHit, { showThumbnail: false, showTitle: true, showContent: true, showCategories: false, noResultsText: larry.search.noPages }))),
                            React.createElement("div", { className: 'wm-searchResultSection -srsVideo' },
                                React.createElement("h2", null, larry.search.videos),
                                React.createElement(Index, { indexName: AvailableIndices.video.index },
                                    React.createElement(Configure, { hitsPerPage: AvailableIndices.video.hitsPerPage, filters: 'lang:' + larry.lang }),
                                    React.createElement(CSHit, { showThumbnail: true, showTitle: true, showContent: false, showCategories: false, noResultsText: larry.search.noPages }))))),
                    React.createElement(SearchFooterPortal, null,
                        React.createElement(ShowIf, { show: isMobile },
                            React.createElement("div", { className: 'wm-searchFooter__content' },
                                React.createElement("div", { className: 'wm-searchFooter__button' },
                                    React.createElement("a", { className: 'wm-button', onClick: onRestartSearchClick, href: "#" }, larry.search.newSearch)))))))));
    };
    ReactRender(React.createElement(SearchContainer, null), $searchRoot.get(0));
});
